<template>
    <div class="login-page">
        <div class="login-page__bg"></div>
        <div class="login-box">
            <div class="card card-outline card-primary">
                <div class="card-header text-center">
                    <a href="javascript:void(0)" class="h3">DBHUB Viewer for Kintone</a>
                </div>
                <div class="text-center mt-2">
                    <img class="logo-login" src="../../assets/img/consulting.svg" alt="" />
                </div>
                <div class="card-body">
                    <p class="login-box-msg"></p>

                    <form autocomplete="off">
                        <div class="form-group mt-4">
                            <span class="reset-password-link"
                                >{{ $t('resetPassword.receiveOtp') }}&nbsp;&nbsp;
                                <a class="btn-link text-danger" href="javascript:void(0)" @click="handleSendEmail">
                                    {{ $t('resetPassword.resent') }}
                                </a>
                            </span>
                        </div>

                        <div class="mb-3">
                            <label for="password" class="mb-0"
                                >{{ $t('resetPassword.otpLabel') }}
                                <span class="text-danger"> *</span>
                            </label>
                            <div class="input-group input-group__password">
                                <input
                                    type="text"
                                    v-model="otp"
                                    @keypress="onValidPhoneNumber"
                                    @paste="onValidPasteOtp"
                                    @keydown="validate('otp')"
                                    @keyup="validate('otp')"
                                    class="form-control"
                                    autocomplete="off"
                                    :class="{ 'input-valid': errorInfo.otp }"
                                    :placeholder="$t('resetPassword.otpLabel')"
                                />
                            </div>
                            <error-message-auth :error="errorInfo.otp"></error-message-auth>
                        </div>

                        <div class="mb-3">
                            <label for="password" class="mb-0"
                                >{{ $t('pageLogin.newPassword') }}
                                <span class="text-danger"> *</span>
                            </label>
                            <div class="input-group input-group__password">
                                <input
                                    :type="isShowPassword ? 'text' : 'password'"
                                    id="password"
                                    v-model="password"
                                    @keydown="validate('password')"
                                    @keyup="validate('password')"
                                    class="form-control"
                                    autocomplete="new-password"
                                    :class="{ 'input-valid': errorInfo.password }"
                                    :placeholder="$t('pageLogin.newPassword')"
                                />
                                <div class="input-group-append">
                                    <div class="input-group-text">
                                        <span class="fas fa-lock"></span>
                                    </div>
                                </div>
                                <span class="password-icon">
                                    <i @click="isShowPassword = !isShowPassword" class="fas" :class="{ 'fa-eye': isShowPassword, 'fa-eye-slash': !isShowPassword }"></i>
                                </span>
                            </div>
                            <error-message-auth :error="errorInfo.password"></error-message-auth>
                        </div>
                        <div class="mb-3">
                            <label for="confirmPassword" class="mb-0"
                                >{{ $t('pageLogin.confirmPassword') }}
                                <span class="text-danger"> *</span>
                            </label>
                            <div class="input-group input-group__password">
                                <input
                                    :type="isShowConfirmPassword ? 'text' : 'password'"
                                    id="confirmPassword"
                                    v-model="confirmPassword"
                                    @keydown="validate('confirmPassword')"
                                    @keyup="validate('confirmPassword')"
                                    @keyup.enter="handleReset"
                                    class="form-control"
                                    autocomplete="off"
                                    :class="{ 'input-valid': errorInfo.confirmPassword }"
                                    :placeholder="$t('pageLogin.confirmPassword')"
                                />
                                <div class="input-group-append">
                                    <div class="input-group-text">
                                        <span class="fas fa-lock"></span>
                                    </div>
                                </div>
                                <span class="password-icon">
                                    <i @click="isShowConfirmPassword = !isShowConfirmPassword" class="fas" :class="{ 'fa-eye': isShowConfirmPassword, 'fa-eye-slash': !isShowConfirmPassword }"></i>
                                </span>
                            </div>
                            <error-message-auth :error="errorInfo.confirmPassword"></error-message-auth>
                        </div>
                    </form>

                    <div class="social-auth-links text-center mt-4 mb-3">
                        <button :disabled="isLoading" v-loading="isLoading" href="javascript:void(0)" class="btn btn-block btn-primary" @click="handleReset">
                            {{ $t('button.login') }}
                        </button>
                    </div>
                    <p class="mb-1 text-back">
                        <span class="mr-2">{{ $t('pageLogin.subGoBackLogin') }}</span>
                        <a href="javascript:void(0)" @click="goPath('/login')">{{ $t('button.login') }}</a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { APP_TOKEN_NAME } from '../../config/constants';
import { validRequired, validPassword, validDuplicator, validNumber } from '../../utils';
import ErrorMessageAuth from '@/views/auth/errorMessageAuth';
import { mapState } from 'vuex';

export default {
    name: 'login',
    components: { ErrorMessageAuth },
    data() {
        return {
            isLoading: false,
            password: '',
            confirmPassword: '',
            otp: '',
            isShowPassword: false,
            isShowConfirmPassword: false,
            errorInfo: {
                confirmPassword: '',
                password: '',
                otp: ''
            }
        };
    },
    mounted() {
        let token = this.$cookies.get(APP_TOKEN_NAME);
        if (token) {
            this.$router.push({ path: '/' });
        }
    },
    computed: {
        ...mapState('auth', ['emailForgot'])
    },
    methods: {
        onValidPhoneNumber(evt) {
            evt = evt || window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) || this.otp.toString().length >= 6) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        onValidPasteOtp(evt) {
            let text = evt.clipboardData.getData('text');
            if (!validNumber(text)) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        goPath(path) {
            if (path) {
                this.$router.push(path);
            }
        },
        handleSendEmail() {
            if (this.emailForgot) {
                if (this.isLoading) return;
                this.isLoading = true;
                let successCallback = (response) => {
                    this.$store.commit('noticeSystem/SET_MESSAGE', {
                        isShowMessage: true,
                        type: 'success',
                        message: this.$t('pageLogin.forgotPasswordSuccess')
                    });
                    this.isLoading = false;
                };
                let errorCallback = () => {
                    this.isLoading = false;
                };
                let payload = {
                    data: {
                        email: this.emailForgot
                    },
                    successCallback,
                    errorCallback
                };
                this.$store.dispatch('auth/forgotPassword', payload);
            }
        },
        handleReset: function () {
            let check = this.validate();
            if (check) {
                if (this.isLoading) return;
                this.isLoading = true;
                let successCallback = (response) => {
                    if (response.status === 200) {
                        this.$store.commit('noticeSystem/SET_MESSAGE', {
                            isShowMessage: true,
                            type: 'success',
                            message: this.$t('resetPassword.resetSuccess')
                        });
                        this.$router.push({ name: 'login' });
                        this.isLoading = false;
                    }
                };
                let errorCallback = (err) => {
                    let messageCode = err.response.data.message;
                    let message = '';
                    if (messageCode === 'auth.otp_not_exit') {
                        message = this.$t('resetPassword.resetFailCode');
                    } else {
                        message = this.$t('resetPassword.resetFailCodeExp');
                    }
                    this.$store.commit('noticeSystem/SET_MESSAGE', {
                        isShowMessage: true,
                        type: 'error',
                        message: message
                    });
                    this.isLoading = false;
                };
                let payload = {
                    data: {
                        otp: this.otp,
                        password: this.password
                    },
                    successCallback,
                    errorCallback
                };

                this.$store.dispatch('auth/changePassword', payload);
            }
        },
        validate(field) {
            let check = true;
            if (field === 'otp' || !field) {
                if (!validRequired(this.otp)) {
                    this.errorInfo.otp = this.$t('resetPassword.errorOtp');
                    check = false;
                } else if (this.otp.length < 6) {
                    check = false;
                    this.errorInfo.otp = this.$t('resetPassword.errorOtpLength');
                } else {
                    this.errorInfo.otp = '';
                }
            }
            if (field === 'password' || !field) {
                if (!validRequired(this.password)) {
                    this.errorInfo.password = this.$t('pageLogin.errorPass');
                    check = false;
                } else if (this.password && !validDuplicator(this.password)) {
                    this.errorInfo.password = this.$t('pageLogin.passSame');
                    check = false;
                } else if (this.password && (!validPassword(this.password) || this.password.length < 8 || this.password.length > 32)) {
                    this.errorInfo.password = this.$t('pageLogin.passFormat');
                    check = false;
                } else {
                    this.errorInfo.password = '';
                }
            }

            if (field === 'confirmPassword' || !field) {
                if (!validRequired(this.confirmPassword)) {
                    this.errorInfo.confirmPassword = this.$t('resetPassword.errorRePass');
                    check = false;
                } else if (this.confirmPassword !== this.password) {
                    this.errorInfo.confirmPassword = this.$t('resetPassword.notMatch');
                    check = false;
                } else {
                    this.errorInfo.confirmPassword = '';
                }
            }

            return check;
        }
    }
};
</script>

<style lang="scss" scoped>
.login-page {
    &__bg {
        background-image: url('../../assets/images/12-8.jpg');
    }
}
</style>
